import { useEffect, useState } from "react";
import img_quarter from "../../../../assets/images/quarter.png";
import { fourTypes } from "../../../../util";
import GroupHeader from "../GroupHeader";
import "./index.css";
import { useCallback } from "react";

function GroupQuarter({
  page,
  total,
  userdata,
  groupinfo,
  rUsers,
  eUsers,
  aUsers,
  lUsers,
}) {
  const [countData, setCountData] = useState([]);
  const [rIdx, setRIdx] = useState(0);
  const [eIdx, setEIdx] = useState(0);
  const [aIdx, setAIdx] = useState(0);
  const [lIdx, setLIdx] = useState(0);

  useEffect(() => {
    let count = { 분석형: 0, 관계형: 0, 도전형: 0, 안정형: 0 };
    userdata.map((user) => {
      count = {
        ...count,
        [user.mainType]: (count[user.mainType] || 0) + 1,
      };
    });
    setCountData(count);
  }, [userdata]);

  const getTypeColor = (type) => {
    if (type === "분석형") return "red";
    else if (type === "관계형") return "skyblue";
    else if (type === "도전형") return "orange";
    else if (type === "안정형") return "darkgreen";
    else return "gray";
  };

  const getTypeFromIndex = (idx) => {
    if (page != 0) return;

    let calc = idx % 12;
    if (calc == 0 || calc == 1 || calc == 2) {
      return "분석형";
    } else if (calc == 3 || calc == 4 || calc == 5) {
      return "관계형";
    } else if (calc == 6 || calc == 7 || calc == 8) {
      return "도전형";
    } else if (calc == 9 || calc == 10 || calc == 11) {
      return "안정형";
    }
  };

  const getNameByIdx = useCallback((idx) => {
    console.log("a", idx);
    // if(page != 0) return;
    // console.log(idx)
    // let calc = idx % 12;
    // let result = null
    // if(calc == 0 || calc == 1 || calc == 2){
    //   result = rUsers[rIdx]
    //   setRIdx(rIdx+1)
    //   console.log(rIdx)
    // }
    // else if(calc == 3 || calc == 4 || calc == 5){
    //   result = eUsers[eIdx]
    //   setEIdx(eIdx+1)
    // }
    // else if(calc == 6 || calc == 7 || calc == 8){
    //   result = aUsers[aIdx]
    //   setAIdx(aIdx+1)
    // }
    // else if(calc == 9 || calc == 10 || calc == 11){
    //   result = lUsers[lIdx]
    //   setLIdx(lIdx+1)
    // }

    // return result
  }, []);

  return (
    <div className="GroupQuarter page">
      <GroupHeader groupinfo={groupinfo} total={total} />

      <h1 style={{ marginLeft: "1.5rem" }}>
        {groupinfo.groupname} 그룹의 관계형 유형 분포 Raw Data
      </h1>
      <div className="quarter-container">
        <img alt="" src={img_quarter} />
      </div>
      <div className="percentage">
        {fourTypes.map((type) => (
          <div key={type.name}>
            <span
              style={{
                color: getTypeColor(type.name),
                marginRight: "0.5rem",
              }}
            >
              ● {type.name}
            </span>
            <b>
              {Math.round((countData[type.name] / userdata.length) * 100 * 10) /
                10}
            </b>
            %
          </div>
        ))}
      </div>
      {/* <div className="user-container">
         {userdata
          .sort((a, b) => {
            if (a.mainType < b.mainType) {
              return -1;
            }
            if (a.mainType > b.mainType) {
              return 1;
            }
            return 0;
          })
          .map((user, index) => (
            <div className="user" key={index}>
              {fourTypes.map((type) => (
                <div key={type.name}>
                  {user.mainType === type.name && (
                    <>
                      <span
                        style={{
                          color: getTypeColor(type.name),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {user.name}
                    </>
                  )}
                </div>
              ))}
            </div>
          ))} */}

      {/* {fourTypes.map((type) => (
          <div key={type.name} className="type">
            <div className="typename">
              <b>{type.name}</b>
            </div>
            {userdata.map((user) => (
              <div className="user">
                {user.mainType === type.name && <>{user.name}</>}
              </div>
            ))}
          </div>
        ))} 
      </div> */}
      <div className="user-container-old-parents">
        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: rUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("분석형"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {rUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: eUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("관계형"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {eUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: aUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("도전형"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {aUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: lUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("안정형"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {lUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupQuarter;
